document.addEventListener("DOMContentLoaded", function () {
  // Find all accordion containers
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach(function (accordion) {
    const items = accordion.querySelectorAll(".accordion-item");
    const buttons = accordion.querySelectorAll("button");

    // Open the first item by default
    if (items.length > 0) {
      items[0].classList.add("active");
      const firstAnswer = items[0].querySelector(".accordion-body");
      if (firstAnswer)
        firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
    }

    // Add click event to all buttons
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        const item = button.parentElement;

        // If the item is already open, close it
        if (item.classList.contains("active")) {
          item.classList.remove("active");
          const answer = item.querySelector(".accordion-body");
          if (answer) answer.style.maxHeight = null;
        } else {
          // Close any other open items in this accordion
          items.forEach(function (otherItem) {
            otherItem.classList.remove("active");
            const answer = otherItem.querySelector(".accordion-body");
            if (answer) answer.style.maxHeight = null;
          });

          // Open the clicked item
          item.classList.add("active");
          const answer = item.querySelector(".accordion-body");
          if (answer) answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  });
});
